import React from "react";
import LoginForm from "@/components/auth/LoginForm";
import SignupForm from "@/components/auth/SignupForm";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import VerifyEmail from "./VerifyEmail";
import { Helmet } from "react-helmet-async";

const AllAuthFormsDemo: React.FC = () => {
  return (
    <div className="bg-sauna-beige min-h-screen py-10 px-2">
      <Helmet>
        <title>All Auth Forms Demo | SaunaDip</title>
        <meta name="description" content="Demo of all authentication forms on one page" />
      </Helmet>
      <div className="max-w-3xl mx-auto space-y-16">
        <section>
          <h2 className="text-2xl font-bold text-sauna-navy mb-6 text-center">Login Form</h2>
          <LoginForm />
        </section>
        <section>
          <h2 className="text-2xl font-bold text-sauna-navy mb-6 text-center">Signup Form</h2>
          <SignupForm />
        </section>
        <section>
          <h2 className="text-2xl font-bold text-sauna-navy mb-6 text-center">Forgot Password Form</h2>
          <ForgotPasswordForm />
        </section>
        <section>
          <h2 className="text-2xl font-bold text-sauna-navy mb-6 text-center">Verify Email Form</h2>
          <VerifyEmail />
        </section>
      </div>
    </div>
  );
};

export default AllAuthFormsDemo; 